/*
 * @Author: 李文敬
 * @version: 1.0.0
 * @Company: 和顺旭基(深圳)中医药科技有限公司
 * @Description:
 * @Date: 2021-07-02 17:00:23
 * @LastEditors: teffy 1825126001@qq.com
 * @LastEditTime: 2025-04-30 17:58:11
 */
/**
 * @desc   公共配置
 * @author yyy
 */
let baseURL, LocPrefix
switch (process.env.NODE_ENV) {
  case `development`:
    baseURL = 'http://47.106.141.82:6603/'
    // baseURL = 'https://rbs.wellsoon.cn/'
    LocPrefix = 'barcode_'
    break
  case `sit`:
    baseURL = 'http://47.106.141.82:6603/'
    LocPrefix = 'barcode_'
    break
  case `uat`:
    baseURL = 'http://47.106.141.82:6603/'
    LocPrefix = 'barcode_'
    break
  case `production`:
    baseURL = 'https://rbs.wellsoon.cn/'
    // baseURL = 'http://47.106.141.82:6603/'
    LocPrefix = 'barcode_'
    break
  default:
    throw new Error('unknown env')
}
export {
  baseURL,
  LocPrefix
}



// WEBPACK FOOTER //
// ./src/config/index.js